const fontSizeObject = {
  h1: { fontSize: "22px" },
  h2: { fontSize: "20px" },
  h3: { fontSize: "14px" },
};

export default fontSizeObject;
